module.exports = __webpack_public_path__ + "static/media/recaptcha.9888b010.png";